import {Directive, ElementRef, Input, OnDestroy, OnInit} from "@angular/core";
import {PrintPreviewService} from "./print-preview.service";

@Directive({
  selector: "[printable]",
})
export class PrintableDirective implements OnInit, OnDestroy {
  private _key: string;

  constructor(private elementRef: ElementRef, private printPreviewService: PrintPreviewService) {}

  @Input("printable")
  set key(key: string) {
    this.printPreviewService.deregister(this._key);
    this._key = key;
    this.printPreviewService.register(this._key, this.elementRef.nativeElement);
  }

  get key(): string {
    return this._key;
  }

  ngOnInit() {
    this.printPreviewService.register(this.key, this.elementRef.nativeElement);
  }

  ngOnDestroy() {
    this.printPreviewService.deregister(this.key);
  }
}
